import { render, staticRenderFns } from "./viewConfigView.vue?vue&type=template&id=a0b4b0aa"
import script from "./viewConfigView.vue?vue&type=script&lang=js"
export * from "./viewConfigView.vue?vue&type=script&lang=js"
import style0 from "./viewConfigView.vue?vue&type=style&index=0&id=a0b4b0aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports